import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {IMappingDefinitions} from './mapping';

/**
 * Service for interacting with mappings.
 * Mapping data is basically list of linkable items from various source systems.
 */
@Injectable()
export class MappingService  {

  protected url = environment.regoApiURL + 'mappinglist';

  private mappings: Promise<IMappingDefinitions[]>;

  /**
   * Default constructor
   * @param {HttpClient} http - refined http service, automatically adds authentication token
   */
  constructor(protected http: HttpClient) {
  }

  public async getMisoNetMappingList(): Promise<IMappingDefinitions> {
    return this.http.get<IMappingDefinitions>(this.url + '/misonet').toPromise();
  }

  public async getPksMappingList(): Promise<IMappingDefinitions> {
    return this.http.get<IMappingDefinitions>(this.url + '/pks').toPromise();
  }

  public async getValmetMappingList(): Promise<IMappingDefinitions> {
    return this.http.get<IMappingDefinitions>(this.url + '/valmet').toPromise();
  }

}
